import { ROUTES } from "./routes";
import {
  LayoutDashboard,
  Bot,
  Megaphone,
  Users,
  Briefcase,
  Calendar,
  MessageSquareShare,
  LineChart,
  UserCog,
  UserCheck,
  Shield,
  Blocks,
  Settings,
  Lock,
  PhoneIncoming,
  PhoneOutgoing,
  PhoneCall,
  PhoneMissed,
  PhoneOff,
  Building,
  Mail,
  Book,
  FileText,
  MessageCircle,
  MessageSquare,
  Activity,
  Car,
  MapPinned,
  BarChart,
  Clock,
  Radio,
  ClipboardCheck,
  ShieldCheck,
  type LucideIcon
} from "lucide-react";

type SidebarNavigationItem = {
  label: string;
  icon: LucideIcon;
  href: string;
  badge?: string;
  badgeColor?: string;
  permission?: string
};

export type SidebarNavigationGroup = {
  section: string;
  items: SidebarNavigationItem[];
};
export const sidebarNavigations: SidebarNavigationGroup[] = [
  {
    section: "Workspace",
    items: [
      {
        label: "Overview",
        icon: LayoutDashboard,
        href: ROUTES.DASHBOARD,
        badge: "Live",
        badgeColor: "green",
      },
      {
        label: "Call Center",
        icon: PhoneIncoming,
        href: ROUTES.DASHBOARD_AGENT,
      },
      {
        label: "Live Calls",
        icon: Radio,
        href: ROUTES.LIVE_CALLS,
        badge: "Live",
        badgeColor: "green",
        permission: "Live Calls",
      },
      {
        label: "Callbacks",
        icon: PhoneCall,
        href: ROUTES.CALLBACKS,
        permission: "Callbacks",
      },
      {
        label: "Missed Calls",
        icon: PhoneMissed,
        href: ROUTES.MISSED_CALLS,
        permission: "Missed Calls",
      },
    ],
  },


  {
    section: "Business Control",
    items: [
      {
        label: "Lead Management",
        icon: Users,
        href: ROUTES.LEAD_MANAGEMENT,
        permission: "Lead Management",
      },
      {
        label: "Scripts",
        icon: FileText,
        href: ROUTES.SCRIPTS,
        permission: "Knowledge Base",
      },
      {
        label: "WhatsApp Assignment",
        icon: MessageSquareShare,
        href: ROUTES.WHATSAPP_ASSIGNMENT,
        permission: "WhatsApp Assignment",
      },
      {
        label: "WhatsApp Templates",
        icon: MessageCircle,
        href: ROUTES.WHATSAPP_TEMPLATES,
        permission: "WhatsApp Templates",
      },
      {
        label: "Team Chat",
        icon: MessageSquare,
        href: ROUTES.TEAM_CHAT,
        badge: "Team",
        badgeColor: "blue",
      },
    ],
  },

  {
    section: "Team Operations",
    items: [
      {
        label: "Property Management",
        icon: Building,
        href: ROUTES.PROPERTY_MANAGEMENT,
        permission: "Property Management",
      },
    ],
  },

  {
    section: "Site Operations",
    items: [
      {
        label: "Site Visit Tickets",
        icon: MapPinned,
        href: ROUTES.SITE_VISITS,
        permission: "Site Visit Tickets"
      },
      {
        label: "Sales Person Assignment",
        icon: UserCheck,
        href: ROUTES.SALES_PERSON_ASSIGNMENT,
        permission: "Sales Person Assignment"
      },
      {
        label: "Transport Management",
        icon: Car,
        href: ROUTES.TRANSPORT_MANAGEMENT,
        permission: "Transport Management"
      },
    ],
  },


  {
    section: "Intelligence",
    items: [
      {
        label: "Marketing Analytics",
        icon: Megaphone,
        href: ROUTES.MARKETING_ANALYTICS,
        permission: "Marketing Analytics",
        badge: "New",
        badgeColor: "blue",
      },
      {
        label: "Conversation Intel",
        icon: Bot,
        href: ROUTES.CONVERSATION_INTEL,
        permission: "Conversation Intel",
      },
      {
        label: "Agent Analytics",
        icon: Activity,
        href: ROUTES.AGENT_ANALYTICS,
        permission: "Agent Analytics",
      },

      {
        label: "Agent Reports",
        icon: Clock,
        href: ROUTES.AGENT_REPORTS,
        permission: "Agent Reports",
      },
      {
        label: "Call Evaluation & Reporting",
        icon: ClipboardCheck,
        href: ROUTES.CALL_EVALUATION_REPORTING,
        permission: "Call Evaluation & Reporting",
      },
      {
        label: "Audit Logs",
        icon: ShieldCheck,
        href: ROUTES.AUDIT_LOGS,
        permission: "Audit Logs",
      },
    ],
  },

  {
    section: "Administration",
    items: [
      // {
      //   label: "Admin Dashboard",
      //   icon: LayoutDashboard,
      //   href: ROUTES.ADMIN_DASHBOARD,
      //   badge: "Super",
      //   badgeColor: "green",
      // },
      {
        label: "User Management",
        icon: UserCog,
        href: ROUTES.USER_MANAGEMENT,
        permission: "User Management",
      },
      {
        label: "Workforce Scheduling",
        icon: Clock,
        href: ROUTES.WORKING_HOURS,
        permission: "Workforce Scheduling",
      },
      {
        label: "Roles & Permissions",
        icon: Shield,
        href: ROUTES.ROLES_PERMISSIONS,
        permission: "Roles & Permissions",
      },
      {
        label: "DID Management",
        icon: PhoneCall,
        href: ROUTES.DID_MANAGEMENT,
        permission: "Integrations",
      },
      {
        label: "Blocked Numbers",
        icon: PhoneOff,
        href: ROUTES.BLOCKED_NUMBERS,
        permission: "Integrations",
      },
      {
        label: "Security",
        icon: Lock,
        href: ROUTES.SECURITY,
        permission: "Security",
      },
      {
        label: "Settings",
        icon: Settings,
        href: ROUTES.SETTINGS,
        permission: "Settings",
      },
    ],
  },
];

